export default {
    getQueryAll()
    {
        let vars = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value)
        {
            vars[key] = value;
        });
        return vars;
    },
    hasQuery(parameter)
    {
        let query = this.getQueryAll();
        return query.hasOwnProperty(parameter);
    },
    getQuery(parameter, default_value)
    {
        let url_parameter = default_value;
        let query = this.getQueryAll();
        if (query.hasOwnProperty(parameter))
        {
            url_parameter = query[parameter];
        }
        return url_parameter;
    }
}